<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filters
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.status') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>LOVE</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="planFilter"
            :options="planOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:planFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.role') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="professionFilter"
            :options="professionOptions"
            class="w-100"
            style="text-transform: capitalize"
            @input="val => $emit('update:professionFilter', val)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.state') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="stateFilter"
            :options="stateOptions"
            class="w-100"
            style="text-transform: capitalize"
            @input="val => $emit('update:stateFilter', val)"
          />
        </b-col>

        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.city') }}</label>
          <v-select
            :value="cityFilter"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            class="w-100"
            multiple
            taggable
            :no-drop="true"
            :close-on-select="false"
            style="text-transform: capitalize"
            @input="val => $emit('update:cityFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.seeking') }}</label>
          <v-select
            id="contracts"
            :value="seekingFilter"
            label="text"
            :placeholder="$t('application.seekingPlaceholder')"
            :options="seekingOptions"
            :reduce="option => option.value"
            @input="val => $emit('update:seekingFilter', val)"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          v-if="seekingFilter === 'long-term' || seekingFilter === 'periodic'"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>{{ $t('application.filters.seekingStart') }}</label>
          <flat-pickr
            v-model="seekingStartStr"
            class="form-control"
            :config="{ time_24hr: true }"
            @on-change="
              date => {
                setDate(date, 'start')
              }
            "
          />
        </b-col>
        <b-col v-if="seekingFilter === 'periodic'" cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.seekingEnd') }}</label>
          <flat-pickr
            v-model="seekingEndStr"
            class="form-control"
            :config="{ minDate: seekingStart, time_24hr: true }"
            @on-change="
              date => {
                setDate(date, 'end')
              }
            "
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.oiwaApplicant') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="oiwaFilter"
            :options="oiwaOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:oiwaFilter', val)"
          />
        </b-col>
        <!-- <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('application.filters.age') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="ageFilter"
            :options="ageOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="val => $emit('update:ageFilter', val)"
          />
        </b-col> -->
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>{{ $t('residency') }}</label>
          <v-select
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :value="residencyFilter"
            :options="residencyOptions"
            :clearable="false"
            :reduce="val => val.value"
            @input="val => $emit('update:residencyFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr,
  },
  props: {
    roleFilter: {
      type: [String, null],
      default: null,
    },
    oiwaFilter: {
      type: [String, null],
      default: null,
    },
    planFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    stateFilter: {
      type: [String, null],
      default: '',
    },
    cityFilter: {
      type: Array,
      default: () => [],
    },
    professionFilter: {
      type: [String, null],
      default: '',
    },
    stepFilter: {
      type: [String, null],
      default: '',
    },
    seekingFilter: {
      type: String,
      default: '',
    },
    seekingStartFilter: {
      type: [Date, Object, String, null],
      default: '',
    },
    seekingEndFilter: {
      type: [Date, Object, String, null],
      default: '',
    },
    ageFilter: {
      type: [String, null],
      default: null,
    },
    residencyFilter: {
      type: [String, null],
      default: null,
    },
    planOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    stateOptions: {
      type: Array,
      required: true,
    },
    professionOptions: {
      type: Array,
      required: true,
    },
    oiwaOptions: {
      type: Array,
      required: true,
    },
    stepOptions: {
      type: Array,
      required: true,
    },
    seekingOptions: {
      type: Array,
      required: true,
    },
    ageOptions: {
      type: Array,
      required: true,
    },
    residencyOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      seekingStart: null,
      seekingEnd: null,
      seekingStartStr: '',
      seekingEndStr: '',
    }
  },
  created() {
    this.seekingStartStr = this.seekingStartFilter
    this.seekingEndStr = this.seekingEndFilter
  },
  methods: {
    setDate(date, slot) {
      if (slot === 'start') {
        ;[this.seekingStart] = date
        this.$emit('update:seekingStartFilter', this.seekingStart)
      }
      if (slot === 'end') {
        ;[this.seekingEnd] = date
        if (this.seekingEnd) {
          this.seekingEnd.setHours(23, 59, 59, 0)
        }
        this.$emit('update:seekingEndFilter', this.seekingEnd)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
</style>
